export default "__VITE_ASSET__B_YxrQOR__"